import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const HeroBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column-reverse",
  gap: "1rem",
  marginTop: "2.5rem",
  width:"100%",
  [theme.breakpoints.down("sm")]: {
    marginTop: "2rem"
  }
}));
